import React, { useState, useEffect } from 'react';
import {
  Table, CardBody, CardTitle, Button,
  Form, FormGroup, Label, Input
} from 'reactstrap';

import Parametri from '../../parametri';
import Clessidra from '../Clessidra.js';
import Interrogativo from '../../immagini/interrogativo-azzurro.png';
import Modale from '../Modale.js';
import TrasformaDateAUmano from '../TrasformaDateAUmano.js';

const STATO_RICERCA_DATI = 1;
const STATO_OPERAZIONE_CORRETTA = 2;
const STATO_ERRORE_CONNESSIONE = 3;
const MODO_ELENCO = 0;
const MODO_NOMINA = 1;
const MODO_DISMISSIONE = 2;
const MODO_MODIFICA_DATA = 3;

function oggiISO() {
  return new Date().toISOString().slice(0, 10);
}

function dataVuota(d) {
  return d === undefined || d === null || d === '';
}

function TabellaSafeguardingResponsabili(props) {
  const [modo, setModo] = useState(MODO_ELENCO);
  const [personaDismissione, setPersonaDismissione] = useState(null);

  const [risultatoServer, setRisultatoServer] = useState([]);
  const [statoPagina, setStatoPagina] = useState(STATO_RICERCA_DATI);
  const [flagModaleInfo, setFlagModaleInfo] = useState(false);

  const [elencoPersone, setElencoPersone] = useState([]);
  const [idpersonaNuovo, setIdpersonaNuovo] = useState('');
  const [dataInizio, setDataInizio] = useState(oggiISO());

  const [idpersonaFine, setIdpersonaFine] = useState('');
  const [dataFine, setDataFine] = useState(oggiISO());

  const [recordModificaData, setRecordModificaData] = useState(null);
  const [nuovaDataInizio, setNuovaDataInizio] = useState('');
  const [nuovaDataFine, setNuovaDataFine] = useState('');

  const oggi = oggiISO();

  const responsabiliAttivi = risultatoServer.filter(r => dataVuota(r.DATAFINE));
  const esisteResponsabileAttivo = responsabiliAttivi.length > 0;

  function preparaModificaDate(r) {
    setRecordModificaData(r);
    setNuovaDataInizio(r.DATAINIZIO || oggiISO());
    setNuovaDataFine(r.DATAFINE || '');
    setModo(MODO_MODIFICA_DATA);
  }

  function modificaDateResponsabile() {
    if (!recordModificaData) return;

    if (nuovaDataInizio < oggi) {
      alert("La data di inizio non può essere precedente a oggi.");
      return;
    }

    if (!dataVuota(nuovaDataFine) && nuovaDataFine < oggi) {
      alert("La data di fine non può essere precedente a oggi.");
      return;
    }

    richiestaServer("safeguardingModificaDateResponsabile", {
      idpersona: recordModificaData.ID,
      dataInizioVecchia: recordModificaData.DATAINIZIO,
      dataInizio: nuovaDataInizio,
      dataFine: nuovaDataFine
    })
      .then(() => {
        setRecordModificaData(null);
        caricaDati();
      })
      .catch(() => alert("Errore durante la modifica delle date."));
  }

  function richiestaServer(op, dati = {}) {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        op,
        emak: props.emak,
        sessionId: props.sessionId,
        ...dati
      })
    };

    return fetch(Parametri("serverURL", props.identitaSelezionata), requestOptions)
      .then(r => r.json())
      .then(valoreDiRitorno => {
        if (valoreDiRitorno.risultatoOperazione === 2) {
          props.setPagina(props.PAGINE.tornaLogin);
          return null;
        }

        if (valoreDiRitorno.risultatoOperazione !== 1) {
          throw new Error("Errore server");
        }

        return valoreDiRitorno;
      });
  }

  function caricaDati() {
    setStatoPagina(STATO_RICERCA_DATI);

    Promise.all([
      richiestaServer("safeguardingElencoResponsabili"),
      richiestaServer("elencoPersone")
    ])
      .then(([respResponsabili, respPersone]) => {
        if (!respResponsabili || !respPersone) return;

        setRisultatoServer(respResponsabili.risultatoRitorno || []);
        setElencoPersone(respPersone.risultatoRitorno || []);

        setStatoPagina(STATO_OPERAZIONE_CORRETTA);
      })
      .catch(() => setStatoPagina(STATO_ERRORE_CONNESSIONE));

      setModo(MODO_ELENCO);
      setPersonaDismissione(null);
  }

  function nominaResponsabile() {
    if (!idpersonaNuovo) {
      alert("Indicare la persona da nominare.");
      return;
    }

    if (dataInizio < oggi) {
      alert("La data di nomina non può essere precedente a oggi.");
      return;
    }

    richiestaServer("safeguardingInizioResponsabile", {
      idpersona: idpersonaNuovo,
      dataInizio
    })
      .then(() => {
        setIdpersonaNuovo('');
        setDataInizio(oggiISO());
        caricaDati();
      })
      .catch(() => alert("Errore durante la nomina del responsabile."));
  }

  function preparaDismissione(idpersona) {
    setIdpersonaFine(idpersona);
    setDataFine(oggiISO());
  }

  function dismettiResponsabile() {
    if (!idpersonaFine) return;

    if (dataFine < oggi) {
      alert("La data di dismissione non può essere precedente a oggi.");
      return;
    }

    richiestaServer("safeguardingFineResponsabile", {
      idpersona: idpersonaFine,
      dataFine
    })
      .then(() => {
        setIdpersonaFine('');
        setDataFine(oggiISO());
        caricaDati();
      })
      .catch(() => alert("Errore durante la dismissione del responsabile."));
  }

  useEffect(() => {
    caricaDati();
  }, []);

  useEffect(() => {
    if (props.flagResetPagine) {
      caricaDati();
      props.callbackFlagResetPagine(false);
    }
  }, [props.flagResetPagine]);

  return (
    <div>
      {statoPagina === STATO_ERRORE_CONNESSIONE &&
        <div>Errore connessione</div>
      }

      {statoPagina === STATO_RICERCA_DATI &&
        <div className="schedaContenitore" style={{ height: props.dimensioniApp.yMain }}>
          <div className="schedaSpazioCentrale" style={{ height: props.dimensioniApp.yMain }}>
            <Clessidra loading={true} />
          </div>
        </div>
      }

      {statoPagina === STATO_OPERAZIONE_CORRETTA &&
        <div style={{
          height: props.dimensioniApp.yMain,
          overflow: "auto",
        }}>

          {flagModaleInfo &&
            <Modale
              larghezza="lg"
              titolo="Responsabili Safeguarding"
              flagErrore={false}
              contenuto={
                <div>
                  Il Responsabile Safeguarding è stato introdotto dalla Riforma dello Sport
                  ed è obbligatorio nelle ASD/SSD.
                  <br /><br />
                  Previene discriminazioni, violenze, bullismo, abusi e gestisce le
                  segnalazioni anche anonime.
                  <br /><br />
                  Attraverso l'app Gestione Sportiva, gli iscritti possono inviare
                  segnalazioni anonime ai Responsabili Safeguarding.
                  <br /><br />
                  Per rispettare la normativa, non è possibile nominare o dismettere responsabili in date precedenti la data di oggi.
                </div>
              }
              bottoni={[
                {
                  etichetta: "OK",
                  tipo: "primary",
                  callback: () => setFlagModaleInfo(false)
                }
              ]}
            />
          }

          <CardBody>
            <CardTitle>
              Elenco Responsabili Safeguarding
            </CardTitle>

            {!esisteResponsabileAttivo && modo === MODO_ELENCO &&
              <div style={{ marginTop: 15, marginBottom: 0 }}>
                <b style={{ color: "red" }}>
                  Attualmente non è attivo nessun Responsabile Safeguarding.
                </b>
              </div>
            }

            {modo === MODO_ELENCO && risultatoServer.length > 0 &&
              <Button
                color="success"
                onClick={() => setModo(MODO_NOMINA)}
                style={{ marginBottom: 15 }}
              >
                Nomina nuovo responsabile
              </Button>
            }

            <img
              src={Interrogativo}
              className="interrogativo"
              alt="aiuto"
              onClick={() => setFlagModaleInfo(true)}
            />

            {(modo === MODO_NOMINA || risultatoServer.length === 0) &&
              <Form>
                <FormGroup>
                  <Label>Persona da nominare:&nbsp;</Label>
                  <Input
                    type="select"
                    value={idpersonaNuovo}
                    onChange={e => setIdpersonaNuovo(e.target.value)}
                  >
                    <option value="">Seleziona...</option>

                    {elencoPersone.map(p => (
                      <option key={p.ID} value={p.ID}>
                        {p.COGNOME} {p.NOME}
                      </option>
                    ))}
                  </Input>
                </FormGroup>

                <FormGroup>
                  <Label>Data nomina</Label>
                  <Input
                    type="date"
                    min={oggi}
                    value={dataInizio}
                    onChange={e => setDataInizio(e.target.value)}
                  />
                </FormGroup>

                <Button color="success" onClick={nominaResponsabile}>
                  Conferma nomina
                </Button>

                {risultatoServer.length > 0 &&
                  <Button
                    color="secondary"
                    onClick={() => setModo(MODO_ELENCO)}
                    style={{ marginLeft: 10 }}
                  >
                    Annulla
                  </Button>
                }
              </Form>
            }

            {modo === MODO_MODIFICA_DATA && recordModificaData &&
              <Form>
                <div style={{ marginBottom: 15 }}>
                  <b>
                    Modifica date Responsabile Safeguarding:{" "}
                    {recordModificaData.COGNOME} {recordModificaData.NOME}
                  </b>
                </div>

                {recordModificaData.DATAINIZIO >= oggi &&
                  <FormGroup>
                    <Label>Data nomina</Label>
                    <Input
                      type="date"
                      min={oggi}
                      value={nuovaDataInizio}
                      onChange={e => setNuovaDataInizio(e.target.value)}
                    />
                  </FormGroup>
                }

                {!dataVuota(recordModificaData.DATAFINE) && recordModificaData.DATAFINE >= oggi &&
                  <FormGroup>
                    <Label>Data dismissione</Label>
                    <Input
                      type="date"
                      min={oggi}
                      value={nuovaDataFine}
                      onChange={e => setNuovaDataFine(e.target.value)}
                    />
                  </FormGroup>
                }

                <Button color="primary" onClick={modificaDateResponsabile}>
                  Conferma modifica
                </Button>

                <Button
                  color="secondary"
                  onClick={() => {
                    setModo(MODO_ELENCO);
                    setRecordModificaData(null);
                  }}
                  style={{ marginLeft: 10 }}
                >
                  Annulla
                </Button>
              </Form>
            }            

            {modo === MODO_DISMISSIONE && personaDismissione &&
              <Form>
                <div style={{ marginBottom: 15 }}>
                  <b>
                    Dismissione Responsabile Safeguarding:
                    {" "}
                    {personaDismissione.COGNOME} {personaDismissione.NOME}
                  </b>
                </div>

                <FormGroup>
                  <Label>Data dismissione</Label>
                  <Input
                    type="date"
                    min={oggi}
                    value={dataFine}
                    onChange={e => setDataFine(e.target.value)}
                  />
                </FormGroup>

                <Button color="danger" onClick={dismettiResponsabile}>
                  Conferma dismissione
                </Button>

                <Button
                  color="secondary"
                  onClick={() => {
                    setModo(MODO_ELENCO);
                    setPersonaDismissione(null);
                    setIdpersonaFine('');
                  }}
                  style={{ marginLeft: 10 }}
                >
                  Annulla
                </Button>
              </Form>
            }
          </CardBody>

          {modo === MODO_ELENCO && risultatoServer.length > 0 &&
            <Table responsive bordered hover striped className="mb-0">
              <thead>
                <tr>
                  <th>Cognome</th>
                  <th>Nome</th>
                  <th>Dal giorno</th>
                  <th>Al giorno</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {risultatoServer.map((r, index) => {
                  const dataInizioModificabile = r.DATAINIZIO >= oggi;
                  const dataFineModificabile = !dataVuota(r.DATAFINE) && r.DATAFINE >= oggi;
                  const recordModificabile = dataInizioModificabile || dataFineModificabile;

                  return (
                    <tr key={`${r.ID}-${r.DATAINIZIO}-${index}`}>
                      <td>{r.COGNOME}</td>
                      <td>{r.NOME}</td>
                      <td><TrasformaDateAUmano data={r.DATAINIZIO}/></td>
                      <td>{dataVuota(r.DATAFINE) ? "" : <TrasformaDateAUmano data={r.DATAFINE}/>}</td>
                      <td>
                        {recordModificabile &&
                          <Button
                            color="primary"
                            onClick={() => preparaModificaDate(r)}
                            style={{ marginRight: 8 }}
                          >
                            Modifica date
                          </Button>
                        }

                        {dataVuota(r.DATAFINE) &&
                          <Button
                            color="danger"
                            onClick={() => {
                              setPersonaDismissione(r);
                              setIdpersonaFine(r.ID);
                              setDataFine(oggiISO());
                              setModo(MODO_DISMISSIONE);
                            }}
                          >
                            Dismetti
                          </Button>
                        }
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          }
        </div>
      }
    </div>
  );
}

export default TabellaSafeguardingResponsabili;